import { PropTypes } from 'prop-types';
import React, { useEffect, useState } from 'react';
import HrbTranslate from '../../language/HrbTranslate';
import { Accordion, AccordionSummary, AccordionDetails, Box } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import styles from './AccordionWithStatus.module.scss';

const AccordionWithStatus = ({ elementId, children, title, translateTitle, isComplete, defaultExpanded }) => {

    const [isExpanded, setIsExpanded] = useState(defaultExpanded);

    useEffect(() => {
        if(isComplete) {
            const timer = setTimeout(() => {
                setIsExpanded(false);
            }, 1500);
        return () => clearTimeout(timer);
        }
    }, [isComplete]);

    return (
        <div className={styles.accordion}>
            <Accordion id={elementId} className={styles.accordionRoot} expanded={isExpanded} 
                    onChange={() => setIsExpanded(prev => !prev)} defaultExpanded={defaultExpanded}>
                <AccordionSummary className={styles.accordionSummary} expandIcon={<ExpandMoreIcon />}>
                    <div className={styles.summaryContent}>
                        { !translateTitle && <p className={styles.accordionTitle}>{title}</p> }
                        {translateTitle && <HrbTranslate className={styles.accordionTitle} text={title} />}
                            {isComplete && (
                            <Box className={styles.status}>
                                <CheckCircleOutlineIcon className={styles.statusIcon}/>
                                {<HrbTranslate text='Common.Status.Complete' />}
                            </Box>
                            )}
                        <div />
                    </div>
                </AccordionSummary>
                <AccordionDetails className={styles.accordionDetails}>
                    {children}
                </AccordionDetails>
            </Accordion>
        </div>
    );
};

AccordionWithStatus.propTypes = {
    elementId: PropTypes.string.isRequired,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    title: PropTypes.string,
    translateTitle: PropTypes.bool,
    isComplete: PropTypes.bool,
    defaultExpanded: PropTypes.bool, 
    expanded: PropTypes.bool
};

export default AccordionWithStatus;